export default __webpack_public_path__ + "static/media/product-4.8f9c82e9.jpg";